export * from './mutations';

export const getChangeRequestsQueryKey = (id: string) => ['onboarding', 'change-requests', id]; // TODO MR to replace with underscores
